import { useState } from "react";
import { editItem } from "../../server/Filter";

const EditorForTitle = ({ name, element, kind, id, placeholder, tag }) => {
  const [value, setValue] = useState(element[name] || "");

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = async () => {
    console.log("in handleBlur with value:", value, "kind:", kind, "id:", id);
    const data = {
      name: value,
    };

    try {
      kind = kind.split("hamazon-")[1];

      const res = await editItem(kind, id, data);
      console.log("Filter updated:", data, res);
    } catch (err) {
      console.error("Error updating filter:", err);
    }
  };

  return (
    <div className="editor-for-title">
      <input
        type="text"
        className={tag || ""}
        placeholder={placeholder || "כותרת פריט"}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default EditorForTitle;
